import { extendTheme, theme as baseTheme } from "@chakra-ui/react";
import { getBranding, type Partner } from "../utils/branding.ts";

// ponytail: branded CTAs come from the active partner's `cta` block; the solid
// variant delegates to the default theme for every other colorScheme. Partners
// without a `cta` never reach here — their buttons use the default solid, which
// already resolves against the partner's `blue` scale below.
const brandedButtonSolid =
  (cta: NonNullable<Partner["cta"]>) =>
  (props: any) => {
    const base =
      (baseTheme.components?.Button?.variants as any)?.solid?.(props) ?? {};
    return props.colorScheme === "blue"
      ? {
          ...base,
          bg: cta.bg,
          color: cta.fg,
          _hover: { ...base._hover, bg: cta.hover },
          _active: { ...base._active, bg: cta.active },
        }
      : base;
  };

const partner = getBranding();

export const theme = extendTheme(
  partner
    ? {
        colors: { blue: partner.blue },
        ...(partner.cta
          ? {
              components: {
                Button: { variants: { solid: brandedButtonSolid(partner.cta) } },
              },
            }
          : {}),
      }
    : {}
);
